import { render, staticRenderFns } from "./feature-card.vue?vue&type=template&id=b3ea5320&scoped=true&"
import script from "./feature-card.vue?vue&type=script&lang=js&"
export * from "./feature-card.vue?vue&type=script&lang=js&"
import style0 from "./feature-card.vue?vue&type=style&index=0&id=b3ea5320&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ea5320",
  null
  
)

export default component.exports